var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-grey"},[_vm._v(" "+_vm._s(_vm.direction)+" "+_vm._s(_vm.dataType)+" "),_c('span',{staticClass:"has-text-grey-light"},[_vm._v(" via")]),_vm._v(" Template: "+_vm._s(_vm.feed.template.name)+" ("+_vm._s(_vm.feed.template.id)+")")])
}
var staticRenderFns = []

export { render, staticRenderFns }